import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/infrastructure/infrastructure.scss';
import '../../css/templates/infrastructure-header.scss';
import '../../css/pages/about/about-fund.scss';

class AboutFundPage {
  constructor() {}

  public init(): void {
    this.bindEvents();
  }

  private bindEvents(): void {}
}

registerPageInit('about-fund', () => {
  const page = new AboutFundPage();
  page.init();
});
